// extracted by mini-css-extract-plugin
module.exports = {"container":"lecturesVideos_container__iEfk3","title":"lecturesVideos_title__qH6i6"};